var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13708_1810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 39.9989C31.0449 39.9989 39.9989 31.0449 39.9989 19.9995C39.9989 8.95407 31.0449 0 19.9995 0C8.95407 0 0 8.95407 0 19.9995C0 31.0449 8.95407 39.9989 19.9995 39.9989Z",
    fill: "#EFB025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3408 21.4727C15.1018 21.4727 16.5293 20.0451 16.5293 18.2842C16.5293 16.5232 15.1018 15.0957 13.3408 15.0957C11.5799 15.0957 10.1523 16.5232 10.1523 18.2842C10.1523 20.0451 11.5799 21.4727 13.3408 21.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6592 21.4727C28.4201 21.4727 29.8477 20.0451 29.8477 18.2842C29.8477 16.5232 28.4201 15.0957 26.6592 15.0957C24.8982 15.0957 23.4707 16.5232 23.4707 18.2842C23.4707 20.0451 24.8982 21.4727 26.6592 21.4727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 30.4658C15.8908 30.4658 13.8358 27.2541 13.7503 27.1169C13.4865 26.6947 13.6153 26.1395 14.0364 25.8757C14.4575 25.6129 15.0116 25.7395 15.2755 26.1585C15.3441 26.2651 16.9124 28.6641 19.9985 28.6641C23.0846 28.6641 24.7132 26.1722 24.729 26.1469C25.0013 25.73 25.5596 25.6129 25.9755 25.8852C26.3924 26.1575 26.5095 26.7158 26.2372 27.1316C26.1486 27.2678 24.0145 30.4658 19.9975 30.4658H19.9996Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13708_1810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.0879c3ec3eb59fb9e957b4be20ad45e4.svg";
export { ForwardRef as ReactComponent };